import routeRegex from "../route_regex"
import ajax from "../ajax"

export function loggedInUser() {
  return window.gon.currentUser
}

export function notLoggedIn() {
  return !loggedInUser()
}

export function getUserId() {
  return loggedInUser()?.userId
}

export function hasRole(role) {
  return loggedInUser()?.role === role
}

export function isPotentialCustomer() {
  return notLoggedIn() || hasRole("user") || hasRole("trial")
}

export function loggedInPotentialCustomer() {
  return hasRole("user") || hasRole("trial")
}

export function isCustomer() {
  return hasRole("payingCustomer") || hasRole("nonPayingCustomer")
}

export function onPageWithLearnMoreBox() {
  return document.querySelectorAll(".learn-more-card").length
}

export function onQuizPage() {
  return window.location.pathname.match(routeRegex("/quizzes"))
}

export function onQuizStartPage() {
  // matching quizzes/<something>
  return window.location.pathname.match(routeRegex("/quizzes/.+"))
}

export function onArticlePage() {
  // match both /<locale>/library/<something>/<something> and
  // /library/<something>/<something>
  return window.location.pathname.match(routeRegex("/library/.+/.+")) ||
    window.location.pathname.match(/^\/library\/.+\/.+/i)
}

export function onStudyUnit() {
  // matching study/<something>
  return window.location.pathname.match(routeRegex("/study/.+"))
}

export function onContentPage() {
  return onQuizStartPage() ||
    onVideoShowPage() ||
    onArticlePage()
}

export function onContentListingPage() {
  return window.location.pathname.match(routeRegex("/start/.+"))
}

export function onAnyRegistrationPage() {
  return window.location.pathname.match(
    routeRegex("/(register|registration-ebook)$")
  )
}

export function onRegistrationPage() {
  return window.location.pathname.match(
    routeRegex("/(register)$")
  )
}

export function onProfileSetupPage() {
  return window.location.pathname.match(
    routeRegex("/(profile/setup)$")
  )
}

export function onEnPage() {
  return window.location.pathname.match(/^\/en\/?/)
}

export function onDePage() {
  return window.location.pathname.match(/^\/de\/?/)
}

export function onEsPage() {
  return window.location.pathname.match(/^\/es\/?/)
}

export function onPtPage() {
  return window.location.pathname.match(/^\/pt\/?/)
}

export function noParams() {
  return window.location.search.length <= 0
}

export function hasParams() {
  return window.location.search.length > 0
}

export function onQuizzesRoot() {
  return window.location.pathname.match(routeRegex("/quizzes/?$")) && noParams()
}

export function onAtlasRoot() {
  return window.location.pathname.match(routeRegex("/atlas/?$")) && noParams()
}

export function onVideosRoot() {
  return window.location.pathname.match(routeRegex("/videos/?$")) && noParams()
}

export function onVideoPage() {
  return window.location.pathname.match(routeRegex("/videos"))
}

export function onVideoShowPage() {
  return window.location.pathname.match(routeRegex("/videos/.+"))
}

export function onAtlasTermPage() {
  return window.location.pathname.match(routeRegex("/atlas/.+"))
}

export function onPricingPage() {
  return window.location.pathname.match(routeRegex("/pricing"))
}

export function onCheckoutPage() {
  return window.location.pathname.match(routeRegex("/checkout"))
}

export function onRegistrationWithTopic() {
  // matches register with query string
  return window.location.pathname.match(
    routeRegex("/(register|registration-ebook)*$")
  ) && window.location.search.match("topic")
}

// matches payment with success query string
export function onPremiumPaymentSuccess() {
  return window.location.pathname.match(
    routeRegex("/payment/status")
  ) && window.location.search.indexOf("succeeded") > -1
}

export function onHomepage() {
  return window.location.pathname.match(routeRegex("?/?$"))
}

export function onDashboard() {
  return window.location.pathname.match(routeRegex("/dashboard"))
}

export function neverTrained() {
  // we can't reliably tell if someone trained if they are not logged in
  // (even if they did, it might have been very long time ago)
  if (notLoggedIn()) return true

  return !window.gon.currentUser?.alreadyTrained
}

export function neverWatchedVideo() {
  // we can't reliably tell if someone watched a video if they are not
  // logged in (even if they did, it might have been very long time ago)
  if (notLoggedIn()) return true

  return window.gon.currentUser?.videosPlayedCount === 0
}

export function experimentTracking(experiment, variant) {
  if (!window.gon.currentUser) return

  const identifier = `${experiment}:${variant}`
  const activeExperiments = window.gon.currentUser?.experiments || []
  if (activeExperiments.includes(identifier)) return

  activeExperiments.push(identifier)
  ajax.post(window.gon.apiExperimentsPath, {experiments: activeExperiments})
}

// takes a HTML string and updates the body with it
export function replaceBody(html) {
  const newPage = document.createElement("html")
  newPage.innerHTML = html
  const body = newPage.querySelector("body")
  const parent = document.body.parentElement
  return parent.replaceChild(body, document.body)
}

// see https://github.com/gingerlime/alephbet/wiki/Tips-&-Caveats#redirects
export function hidePage() {
  const style = document.createElement("style")
  style.setAttribute("type", "text/css")
  style.innerHTML = "body{ display:none; visibility:hidden; }"
  document.head.appendChild(style)
  return style
}

export function isNewCustomer() {
  const subCreatedAt = window.gon.currentUser?.subscriptionStartedAt
  if (!subCreatedAt) return false

  const now = Math.floor(Date.now() / 1000) // in seconds
  const oneWeekAgo = now - 7 * 24 * 60 * 60 // in seconds
  return subCreatedAt >= oneWeekAgo
}

export function now() {
  return Math.floor(Date.now() / 1000)
}
